exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614]{display:inline-block;font-size:14px;line-height:50px;margin-left:10px}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614]{color:#97a8be;cursor:text}", ""]);

// exports
